import gql from 'graphql-tag';

export const GET_ADDITIONAL_OFFER_DATA = gql`
  query ($webUserId: ID!) {
    getAdditionalOfferData(webUserId: $webUserId) {
      webUserId
      termLifeLastSubmitted
    }
  }
`;

export const SET_ADDITIONAL_OFFER_DATA = gql`
  mutation setAdditionalOfferData($additionalOfferData: AdditionalOfferDataInput!) {
    setAdditionalOfferData(additionalOfferData: $additionalOfferData) {
      webUserId
      termLifeLastSubmitted
    }
  }
`;

export const CREATE_BIX_AUTO_OFFER_UPSELL = gql`
  mutation CreateBixAutoOfferUpsell($input: CreateBixAutoOfferUpsellInput!) {
    createBixAutoOfferUpsell(input: $input) {
      __typename
      ... on CreateBixAutoOfferUpsellSuccess {
        offerId
        autoMonthlyPremium
      }
      ... on CreateBixAutoOfferUpsellRejection {
        message
      }
      ... on CreateBixAutoOfferUpsellNotEligible {
        message
      }
      ... on CreateBixAutoOfferUpsellError {
        message
      }
    }
  }
`;
